@if (hasProfile){
@if (isProduction || !isVsnBU) {
<div id="page" class="admin-ui-page">
    <adminui-navbar></adminui-navbar>

    @if (showWelcomeDialog){
    <adminui-welcome-dialog></adminui-welcome-dialog>
    }

    <main role="main">
        <router-outlet></router-outlet>

        @if (showNotification){
        <div role="alert" class="alert toast-alert toast-main alert-info alert-sm alert-dismissible fade in">
            <button type="button" class="close" (click)="closeNotification()">
                <span aria-hidden="true">&times;</span><span class="sr-only">Close</span>
            </button>
            @if(notificationItem?.url){
            <a href="#" rel="noopener noreferrer" (click)="onClickNotification($event)">
                <div>
                    <span>{{notificationTitle}}</span>
                </div>
            </a>
            } @else {
            <div>
                <span>{{notificationTitle}}</span>
            </div>
            }
        </div>
        }

        <adminui-loading-widget></adminui-loading-widget>
        <adminui-alert-flash alertFlashName="mainFlashAlert"></adminui-alert-flash>
        <adminui-alert-error alertErrorName="mainErrorAlert"></adminui-alert-error>

    </main>

    <footer>
    </footer>
</div>
} @else {
<adminui-nav-shell>

    @if (showWelcomeDialog){
    <adminui-welcome-dialog></adminui-welcome-dialog>
    }

    <main role="main">
        <router-outlet></router-outlet>

        @if (showNotification){
        <div role="alert" class="alert toast-alert toast-main alert-info alert-sm alert-dismissible fade in">
            <button type="button" class="close" (click)="closeNotification()">
                <span aria-hidden="true">&times;</span><span class="sr-only">Close</span>
            </button>
            @if(notificationItem?.url){
            <a href="#" rel="noopener noreferrer" (click)="onClickNotification($event)">
                <div>
                    <span>{{notificationTitle}}</span>
                </div>
            </a>
            } @else {
            <div>
                <span>{{notificationTitle}}</span>
            </div>
            }
        </div>
        }

        <adminui-loading-widget></adminui-loading-widget>
        <adminui-alert-flash alertFlashName="mainFlashAlert"></adminui-alert-flash>
        <adminui-alert-error alertErrorName="mainErrorAlert"></adminui-alert-error>

    </main>

    <footer>
    </footer>

</adminui-nav-shell>
}
}